// External Dependencies:
import React from 'react'

// Internal Dependencies:
import Editable from 'church-theme-library/components/Editable/Editable'

class Heading extends React.Component {
	render() {
		const { contentId, sectionId, data } = this.props

		return (
			<div className="section-heading">
				<div className="-inner">
					<div className="-content">
						<Editable
							element="h2"
							id={ contentId }
							sectionId={ sectionId }
							sectionType={ data.type }
							sectionDataId="heading"
							content={ data.heading }
						/>
					</div>
				</div>
			</div>
		)
	}
}

export default Heading
